export const PageContainer = ({children}) => {
    return (
        <div className='martrak-page-content-margin flex flex-col'>{children}</div>
    )
}